<div class="media-form-container">
  <div
    *ngIf="media$ | async as m; else noMedia"
    class="media"
    [title]="m?.name">
    <img loading="lazy" [src]="m?.previewUrl">
    <span
      class="media-name"
      *ngIf="m?.type === 'application/pdf'">
      {{ m?.name }}
    </span>
  </div>

  <ng-template #noMedia>
    <span>
      {{ 'Nessun media presente' | translate }}
    </span>
  </ng-template>

  <div class="media-form-actions">
    <button
      mat-icon-button
      type="button"
      *ngIf="media"
      (click)="uiMediaService.dispatchViewMediaAction(media)">
      <mat-icon>visibility</mat-icon>
    </button>
    <button
      mat-icon-button
      type="button"
      (click)="showMediaPickerHandler()">
      <mat-icon *ngIf="!media">add</mat-icon>
      <mat-icon *ngIf="media">edit</mat-icon>
    </button>
    <button
      mat-icon-button
      type="button"
      *ngIf="media"
      (click)="removeMediaHandler()">
      <mat-icon>delete</mat-icon>
    </button>
  </div>
</div>
